import {SIC} from "@/store/api/sicApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SICState {
    sics: SIC[];
}

const initialState: SICState = {
    sics: [],
}

const sicSlice = createSlice({
    name: "sics",
    initialState,
    reducers: {
        setSIC: (state, action: PayloadAction<SIC[]>) => {
            state.sics = action.payload;
        },
        clearSIC: (state) => {
            state.sics = [];
        }
    }
})


export const { setSIC, clearSIC } = sicSlice.actions;
export default sicSlice.reducer;
